import { SCHEDULER_PROCESS_STATUS } from "../../constants/constants";

// How long the report page waits for a download before telling the user it will be
// emailed instead. The server emails any download that finishes more than 20 s after the
// click (EMAIL_DOWNLOAD_AFTER_SECONDS in backend/report/utils.py); keep the two in step.
export const DOWNLOAD_WAIT_SECONDS = 30;

/**
 * Whether to make one last status check now. The regular poll runs every 10 s, so at the
 * limit the page's last answer can be up to 10 s old -- a job that finished a moment ago
 * still reads RUNNING, and the file reached neither the browser nor the inbox.
 */
export const shouldRunFinalCheck = (
  status: number | undefined,
  intervalCount: number,
  finalCheckStarted: boolean
): boolean =>
  status === SCHEDULER_PROCESS_STATUS.RUNNING &&
  intervalCount >= DOWNLOAD_WAIT_SECONDS &&
  !finalCheckStarted;

/**
 * Whether the final check's answer means giving up. A finished or failed job is left to
 * the polling effect, which downloads the file or reports the failure as it always has.
 */
export const shouldGiveUpAfterFinalCheck = (
  status: number | undefined
): boolean =>
  status !== SCHEDULER_PROCESS_STATUS.COMPLETED &&
  status !== SCHEDULER_PROCESS_STATUS.FAILED;
